var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.validationErrors)?_c('v-alert',{attrs:{"prominent":"","type":"error","outlined":""}},_vm._l((_vm.validationErrors),function(v,k){return _c('ul',{key:k,staticClass:"d-flex justify-center align-center"},_vm._l((v),function(error){return _c('li',{key:error,staticClass:"text-sm"},[_vm._v(" "+_vm._s(error)+" ")])}),0)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }